export interface ConfigSettings {
    env: "dev" | "test" | "prod";
    customerAuthSubdomain: string;
    authWebsiteUrl: string;
    authority: string;
    graphqlUrl: string;
    datafileUrl: string;
    uploadFileUrl: string;
    uploadFileBulkUrl: string;
    openThumbnailUrl: string;
    getCustomerPortalUrl: string;
    getTenancyIndexCsvFile: string;
    downloadCustomerInvoicedFiles: string;
    downloadFileVersion2: string;
    openFileWithTokenUrl: string;
    openFileWithFilename: string;
    brandAssets: {
        uploadLogo: string;
        uploadColors: string;
        logoImage: string;
        css: string;
    };
    sentryUrl: string;
    timeout: number;
    proxy: string;
    clientId: string;
    responseType: string;
    scope: string;
    upsertNewsUrl: string;
    insertNotificationUrl: string;
    getCitiesUrl: string;
    getStreetsInCityUrl: string;
    getStreetNumbersInStreetUrl: string;
    copySignaturesOnly: string;
    systemHealthUrl: string;
    graphqlWssUrl: string;
    createIncidentUrl: string;
    createOrderUrl: string;
    checkIncidentCanBeCompletedUrl: string;
    closeIncidentUrl: string;
    assignIncidentToUserUrl: string;
    orderCloseUrl: string;
    updateIncidentPersonsUrl: string;
    concludeUserAssignedUrl: string;
    concludeRealestateAssignedUrl: string;
    orderRetrySubmission: string;
    yarowaDashboardDefaultUrl: string;
    activateService: string;
    deactivateService: string;
    getTicketingCostMonth: string;
    environment: string;
    sendManualEmailUrl: string;
    updateUserStatusUrl: string;
    isMaintenanceActive: boolean;
    setNewEmail: string;
    setMfa: string;
    setMfaMandatory: string;
    setMfaForCustomer: string;

    // assembly
    downloadAssemblyFiles: string;
    downloadAgendaItemFiles: string;
    copyagendaitemsLastAssembly: string;
    copyagendaitemTemplates: string;
    newCopyagendaitems: string;
    newCopyagendaitemsWithText: string;
    newCopyagendaitemTemplates: string;
    generateassemblyrealestatepdf: string;
    generateattendancelistpdf: string;
    generateassemblyprotocolpdf: string;
    updateAssemblyRealestateTenantState: string;
    setTenantVotingResult: string;
    getVotingAgendaitemResult: string;
    getVotingAgendaitemQuorumState: string;
    calcVotingAgendaitemQuorumState: string;
    actualizeAssemblyRealestateTenants: string;
    differencesAssemblyRealestateTenants: string;

    // cidaas
    wwPortalClientId: string;
    cidaasBaseUrl: string;
    cidaasChangePasswordRessource: string;
    cidaasAuthorisationServerRessource: string;
    cidaasGetTokenRessource: string;
    cidaasEndSessionRessource: string;

    // krediflow
    extractDataSinglePdfUrl: string;
    aiDetectWithFileUrl: string;
    createInvoiceUrl: string;
    approveOrRejectInvoiceUrl: string;
    concludeHumanTaskUrl: string;
    cancelInvoiceUrl: string;
    createInputWorkflowUrl: string;
    checkAssignedWorkflowUsersUrl: string;
    getFileUploadUrl: string;
    cancelInputWorkflowUrl: string;
    abortInputWorkflowProcessUrl: string;
    abortInvoiceProcessUrl: string;
    pdfSplitManuallyUrl: string;
    incidentArchive: string;
    getDuplicatesUrl: string;
    getInvoiceFilesUrl: string;
    copyUser: string;
}

const isLocal = window.location.host.indexOf("localhost") === 0;
const proxy = isLocal ? "https://localhost.wwportal.ch" : `${window.location.protocol}//${window.location.host}`;
const subdomain = isLocal ? "localhost" : window.location.host.split(".")[0];
const customerAuthSubdomain = isLocal ? "dev" : window.location.host.split(".")[0];
const wwCidaasBaseUrl = `${proxy}/api/cidaas-webhook`;

export const NetworkConfig = {
    graphqlUrl: "https://ww-prod-hasura-cidaas-wa.azurewebsites.net/v1/graphql",
    customerAuthSubdomain: customerAuthSubdomain,
    authWebsiteUrl: "https://auth.wwportal.ch",
    authority: `${proxy}/auth`,
    datafileUrl: `${proxy}/api/v2/files/open/`,
    openFileWithFilename: `${proxy}/api/v2/files/openwithfilename/`,
    uploadFileUrl: `${proxy}/api/v2/files/upload`,
    uploadFileBulkUrl: `${proxy}/api/v2/files/uploadbulk`,
    openThumbnailUrl: `${proxy}/api/v2/files/openthumbnail/`,
    getCustomerPortalUrl: `${proxy}/api/customer/getcustomerportalurl`,
    getTenancyIndexCsvFile: `${proxy}/api/customer/tenancyindex`,
    downloadAssemblyFiles: `${proxy}/api/portal/getzipassemblyfiles`,
    downloadCustomerInvoicedFiles: `${proxy}/api/portal/getcustomerinvoicedfiles`,
    downloadAgendaItemFiles: `${proxy}/api/portal/getzipagendaitemfiles`,
    activateService: `${proxy}/api/portal/activate_service/`,
    deactivateService: `${proxy}/api/portal/deactivate_service/`,
    downloadFileVersion2: `${proxy}/api/v2/files/download2`,
    openFileWithTokenUrl: `${proxy}/api/v2/files/open-with-token`,
    brandAssets: {
        uploadLogo: `${proxy}/api/v2/files/upload/logo/${subdomain}`,
        uploadColors: `${proxy}/api/v2/files/upload/css/${subdomain}`,
        logoImage: `${proxy}/api/designs/logo/brand.jpg?t=${new Date().getTime()}`,
        css: `${proxy}/api/designs/css/brand.css`
    },
    sentryUrl: "https://cc27df4003a645fa959a0fe62b47602a@o421140.ingest.sentry.io/5340447",
    proxy,
    clientId: "WWPortalClient",
    responseType: "code",
    scope: "offline_access wwimmo.mobile.core.api IdentityServerApi",
    upsertNewsUrl: `${proxy}/api/news/news`,
    insertNotificationUrl: `${proxy}/api/notification/eventqueue`,
    getCitiesUrl: `${proxy}/api/rest/common/cities`,
    getStreetsInCityUrl: `${proxy}/api/rest/common/streets`,
    getStreetNumbersInStreetUrl: `${proxy}/api/rest/common/streetnumbers`,
    copyagendaitemsLastAssembly: `${proxy}/api/rest/cond/copyagendaitems`,
    copyagendaitemTemplates: `${proxy}/api/rest/cond/copyagendaitemtemplates`,
    newCopyagendaitems: `${proxy}/api/rest/cond/newcopyagendaitems`,
    newCopyagendaitemsWithText: `${proxy}/api/rest/cond/newcopyagendaitemswithtext`,
    newCopyagendaitemTemplates: `${proxy}/api/rest/cond/newcopyagendaitemtemplates`,
    copySignaturesOnly: `${proxy}/api/rest/cond/copysignaturesonly`,
    systemHealthUrl: `${proxy}/api/health`,
    graphqlWssUrl: "wss://ww-prod-hasura-wa.azurewebsites.net/v1/graphql",
    createIncidentUrl: `${proxy}/api/ticket/incident/create`,
    createOrderUrl: `${proxy}/api/ticket/order/create`,
    checkIncidentCanBeCompletedUrl: `${proxy}/api/ticket/incident/checksetcompleted`,
    closeIncidentUrl: `${proxy}/api/ticket/incident/closeticket`,
    assignIncidentToUserUrl: `${proxy}/api/ticket/incident/assignuser`,
    orderCloseUrl: `${proxy}/api/ticket/order/close`,
    updateIncidentPersonsUrl: `${proxy}/api/ticket/incident/updateincidentpersons`,
    concludeUserAssignedUrl: `${proxy}/api/ticket/incident/concludeuserassigned`,
    concludeRealestateAssignedUrl: `${proxy}/api/ticket/incident/concluderealestateassigned`,
    orderRetrySubmission: `${proxy}/api/ticket/order/retrysubmission`,
    yarowaDashboardDefaultUrl: "https://www-appenzell-pool.enable.jarowa.ch/dashboard",
    getTicketingCostMonth: `${proxy}/api/customer/getticketingcost`,
    sendManualEmailUrl: `${proxy}/api/ticket/incident/sendmanualemail`,
    generateassemblyrealestatepdf: `${proxy}/api/portal/generateassemblyrealestatepdf/`,
    generateattendancelistpdf: `${proxy}/api/portal/generate-attendance-list-pdf/`,
    generateassemblyprotocolpdf: `${proxy}/api/portal/generate-assembly-protocol-pdf/`,
    incidentArchive: `${proxy}/api/ticket/incident/archive`,
    environment: "<placeholder>",
    wwPortalClientId: "<placeholder>",
    cidaasBaseUrl: "<placeholder>",
    cidaasChangePasswordRessource: "/users-srv/changepassword",
    cidaasEndSessionRessource: "/session/end_session",
    cidaasAuthorisationServerRessource: "/authz-srv/authz",
    cidaasGetTokenRessource: "/token-srv/token",
    updateUserStatusUrl: `${wwCidaasBaseUrl}/update-user-status`,
    setNewEmail: `${wwCidaasBaseUrl}/set_new_email_by_self`,
    setMfa: `${wwCidaasBaseUrl}/toggle-mfa-enabled`,
    setMfaMandatory: `${wwCidaasBaseUrl}/set-mfa-mandatory`,
    setMfaForCustomer: `${wwCidaasBaseUrl}/toggle-mfa-enabled-customer`,
    isMaintenanceActive: false,
    extractDataSinglePdfUrl: `${proxy}/api/krediflow/extract-data-single-pdf`,
    aiDetectWithFileUrl: `${proxy}/api/krediflow/ai-detect-with-file`,
    createInvoiceUrl: `${proxy}/api/krediflow/createinvoice`,
    approveOrRejectInvoiceUrl: `${proxy}/api/krediflow/invoice/approve`,
    cancelInvoiceUrl: `${proxy}/api/krediflow/invoice/cancel`,
    concludeHumanTaskUrl: `${proxy}/api/krediflow/concludehumantask`,
    createInputWorkflowUrl: `${proxy}/api/krediflow/input/createinputworkflow`,
    checkAssignedWorkflowUsersUrl: `${proxy}/api/krediflow/checkassignedworkflowusers`,
    getFileUploadUrl: `${proxy}/api/krediflow/input/get-file-upload-url`,
    cancelInputWorkflowUrl: `${proxy}/api/krediflow//inputworkflow-cancel`,
    abortInputWorkflowProcessUrl: `${proxy}/api/krediflow/abort-inputworkflow-process`,
    abortInvoiceProcessUrl: `${proxy}/api/krediflow/abortinvoiceprocess`,
    pdfSplitManuallyUrl: `${proxy}/api/pdf/pdf_split_manually`,
    updateAssemblyRealestateTenantState: `${proxy}/api/rest/cond/update_assembly_realestate_tenant_state`,
    getDuplicatesUrl: `${proxy}/api/krediflow/get-duplicates`,
    getInvoiceFilesUrl: `${proxy}/api/krediflow/get-invoice-files`,
    setTenantVotingResult: `${proxy}/api/rest/survey/settenantvotingresults`,
    copyUser: `${proxy}/api/customer/copy_user`,
    getVotingAgendaitemResult: `${proxy}/api/portal/get-voting-agendaitem-result/`,
    getVotingAgendaitemQuorumState: `${proxy}/api/portal/get-voting-agendaitem-quorum-state/`,
    calcVotingAgendaitemQuorumState: `${proxy}/api/portal/calculate-voting-agendaitem-quorum-state/`,
    actualizeAssemblyRealestateTenants: `${proxy}/api/rest/actualize_assembly_realestate_tenants_by_assemblyid`,
    differencesAssemblyRealestateTenants: `${proxy}/api/rest/differences_assembly_realestate_tenants`
} as ConfigSettings;
